// extracted by mini-css-extract-plugin
export var container = "BackgroundMedia-module--container--7b5c6";
export var image = "BackgroundMedia-module--image--2a4ea";
export var video = "BackgroundMedia-module--video--b32d9";